
import * as React from "react"

import { cn } from "@/lib/utils"

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  decimalPrecision?: number;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, decimalPrecision, ...props }, ref) => {
    // Handler for precision input
    const handlePrecisionChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      if (type === "number" && decimalPrecision !== undefined && props.onChange) {
        const value = e.target.value;
        if (value === "") {
          props.onChange(e);
          return;
        }
        
        // Format the number to have the specified decimal precision
        const numValue = parseFloat(value);
        if (!isNaN(numValue)) {
          const formattedValue = numValue.toFixed(decimalPrecision);
          // Only update if the formatted value is different
          if (value !== formattedValue && !value.includes('.')) {
            e.target.value = formattedValue;
          }
        }
        
        props.onChange(e);
      }
    };

    // Calculate step safely to avoid negative values in String.repeat
    const getStepValue = () => {
      if (decimalPrecision === undefined || type !== "number") {
        return undefined;
      }
      
      if (decimalPrecision <= 0) {
        return "1"; // Inteiro sem casas decimais
      }
      
      return `0.${"0".repeat(Math.max(0, decimalPrecision - 1))}1`;
    };

    return (
      <input
        type={type}
        className={cn(
          "w-full px-3 py-2 rounded-md border transition-colors duration-200",
          "bg-white text-gray-900 placeholder:text-gray-400",
          "focus:outline-none focus:ring-2 focus:ring-offset-0 focus:ring-blue-100 focus:border-blue-500",
          "border-gray-200 hover:border-blue-300",
          "disabled:cursor-not-allowed disabled:opacity-50 disabled:bg-gray-50",
          className
        )}
        ref={ref}
        onChange={decimalPrecision !== undefined && type === "number" ? handlePrecisionChange : props.onChange}
        step={getStepValue()}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

export { Input }
